export enum SubtitleOption {
	"None" = 'none',
	"Included" = 'included',
	"Separated" = 'separated'
}